import React from "react";

const Status = ({selectedStatus, onSelectedStatus}) => {
  return (
    <div className="pb-2 w-1/3 mb-2 ml-3">
      <select
        id="Status"
        value={selectedStatus}
        className="bg-white w-full text-xs text-gray-800 py-1 pl-3 leading-normal font-normal border border-gray-300 rounded-lg focus:border-gray-300 focus:outline-none focus:ring-0"
        onChange={onSelectedStatus}
      >
        <option value="" disabled >Select Status</option>
        <option value="verified">Verified</option>
        <option value="document_upload">Document Upload</option>
        <option value="action_required">Action Required</option>
        <option value="not_verified">Not Verified</option>
        <option value="action_required">Action Required</option>
        <option value="under_approval">Under Approval</option>
        <option value="rejected">Rejected</option>
      </select>
    </div>
  );
};
export default Status;
